<template>
<div class="chapter">
<div class="inner_page">
<div id="Dedication1">
<p class="deda">The only thing that frightened me during the entire war, were the periscopes of the German submarines – and the spirit of their crews – unbroken up to the end.</p>
<p class="right"><i>Winston Churchill</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Dedication1.vue?61b893ba